export default "__VITE_ASSET__66ce719f__"